/* eslint-disable @next/next/no-img-element */
import Image from "next/image";

import placeholder from "shared/assets/images/mock_empty.svg";
import iconPlay from "shared/assets/images/play.svg";

import { Container, ContainerIconPlay, ImageSection } from "./styles";

interface ICourseThumbWithPlay {
  hasTrailer?: boolean;
  image_thumbnail: string;
}

const CourseThumbWithPlay = ({
  hasTrailer,
  image_thumbnail,
}: ICourseThumbWithPlay) => {
  return (
    <Container>
      {hasTrailer && (
        <ContainerIconPlay>
          <div className="centralizer">
            <Image src={iconPlay} alt="icon-play" fill className="icon-play" />
          </div>
        </ContainerIconPlay>
      )}

      <ImageSection>
        <img
          src={image_thumbnail || placeholder}
          alt="Thumbnail"
          className="course-thumb-img"
        />
      </ImageSection>
    </Container>
  );
};

export default CourseThumbWithPlay;
